'use client';

import { FC, useMemo, useCallback, useState } from 'react';
import { RolloverItemProps } from './RolloverItem.types';
import {
  Flex,
  Pill,
  Text,
  Separator,
  Button,
  ButtonGroup,
} from '@/_components';
import styles from './RolloverItem.module.css';
import { SCHEDULE_ITEMS } from '@/_constants/questionnaires';
import { ViewScheduleLineItemsDialog } from '@/_components/ViewSchedudeLineItemsDialog';

export const RolloverItem: FC<RolloverItemProps> = ({
  item,
  onEdit,
  onDelete,
  companyId,
  isDisabled,
  isDuplicate,
}) => {
  const { name, source, do_not_rollover } = item;
  const hasButtons: boolean = !!onEdit || !!onDelete;
  const [isViewScheduleLineItemsDialogOpen, setIsViewScheduleLineItemsOpen] =
    useState(false);

  const isScheduleItem = useMemo(() => {
    return SCHEDULE_ITEMS.includes(name.toLowerCase().split(' (')[0]);
  }, [name]);

  const showViewScheduleLineItemsDialog = useCallback(() => {
    setIsViewScheduleLineItemsOpen(true);
  }, []);

  const onCloseViewScheduleLineItemsDialog = useCallback(() => {
    setIsViewScheduleLineItemsOpen(false);
  }, []);

  return (
    <>
      {item && (
        <ViewScheduleLineItemsDialog
          isOpen={isViewScheduleLineItemsDialogOpen}
          companyId={companyId}
          priorYearItemId={item.id}
          priorYearItemName={item.name}
          onClose={onCloseViewScheduleLineItemsDialog}
        />
      )}
      <Flex
        isBetween={true}
        gap={2}
        isYCentered={true}
        paddingX={4}
        paddingY={6}
        className={styles.rolloverItem}
      >
        <Text type="small">{name}</Text>
        <Flex isYCentered={true} gap={6}>
          {do_not_rollover && (
            <Pill size="small" intent="secondary" label="Not rolled over" />
          )}
          {isDuplicate && (
            <Pill size="small" intent="danger" label={'duplicate'} />
          )}
          {source && <Pill size="small" intent="secondary" label={source} />}
          {hasButtons && (
            <>
              {isScheduleItem && (
                <Button
                  value="View line items"
                  intent="secondary"
                  onClick={showViewScheduleLineItemsDialog}
                  size="tiny"
                  isIconOnly={true}
                  withTooltip={true}
                  isDisabled={isDisabled}
                  iconLeft="list-dashes"
                />
              )}

              <Separator isVertical={true} height={24} isLight={true} />
              <ButtonGroup isSmallGroup={true} isSameLine={true}>
                {onEdit && (
                  <Button
                    value="Edit"
                    intent="secondary"
                    onClick={onEdit}
                    size="tiny"
                    isIconOnly={true}
                    withTooltip={true}
                    isDisabled={isDisabled}
                    iconLeft="pencil"
                  />
                )}
                {onDelete && (
                  <Button
                    value="Delete"
                    intent="danger-secondary"
                    onClick={onDelete}
                    size="tiny"
                    isIconOnly={true}
                    isDisabled={isDisabled}
                    withTooltip={true}
                    iconLeft="trash"
                  />
                )}
              </ButtonGroup>
            </>
          )}
        </Flex>
      </Flex>
    </>
  );
};
